import React, { FC } from 'react';

import {
  StanleyQueryError,
  StanleyQueryFormContainer,
  StanleyQueryResults,
} from './components';
import { StanleyQueryHistory } from '../stanley-query-history';
import {
  useStanleyQueryPanel,
  PANEL_VIEWS,
} from '../../providers/StanleyQueryPanelContext';
import { isStanleyQueryCreditsExpiredError } from '../../../../api/errors';

export const StanleyQueryPanelContainer: FC = () => {
  const {
    view,
    isLoading,
    isError,
    error,
    stanleyQueryData,
    formResetKey,
    isFetchingHistoryItem,
    isCreditsExpired,
  } = useStanleyQueryPanel();

  const showGenericError =
    isError &&
    !isLoading &&
    !isCreditsExpired &&
    !isStanleyQueryCreditsExpiredError(error);

  return (
    <div className="min-h-0 flex flex-col flex-1 justify-between overflow-auto px-4 pt-4 pb-16 bg-hx-light-dark">
      {view === PANEL_VIEWS.HISTORY ? (
        <StanleyQueryHistory />
      ) : showGenericError ? (
        <StanleyQueryError />
      ) : view === PANEL_VIEWS.RESULTS &&
        stanleyQueryData &&
        !isLoading &&
        !isFetchingHistoryItem ? (
        <StanleyQueryResults data={stanleyQueryData} />
      ) : (
        <StanleyQueryFormContainer key={formResetKey} />
      )}
    </div>
  );
};
